
import Vue, { PropType } from "vue";
import { IItemsToManipulate } from "./OrderReplacementNew.vue";
import UIMoneyFormat from "@/components/UI/Money/UIMoneyFormat.vue";
import increaseQtyBtn from "@/components/Cart/CartActions/IncreaseItemCart.vue"
import decreaseQtyBtn from "@/components/Cart/CartActions/DecreaseItemCart.vue"
import Product, { WeightedProductUnitMeasure } from "@/models/Product";

export enum EItemReplacementStatus {
    removedFromOrder,
    replacementDiscarded,
    pendingSelection,
    replaced
}

export default Vue.extend({

    components: {
        "money-format": UIMoneyFormat,
        "increase-btn": increaseQtyBtn,
        "decrease-btn": decreaseQtyBtn,
    },

    props: {
        parentItemObject: {
            type: Object as PropType<IItemsToManipulate>,
            required: false
        },

        itemObject: {
            type: Object as PropType<IItemsToManipulate>,
            required: true
        },

        currentSelectedReplacement: {
            type: Product,
            required: false
        },

        isReplacementOption: {
            type: Boolean,
            required: false
        },

        isSelectedAsReplacement: {
            type: Boolean,
            required: false
        },

        isDialogOpened: {
            type: Boolean,
            required: false
        },
    },

    data: () => ({
        eItemReplacementStatus: EItemReplacementStatus,
        currenyQuantity: 1 as number
    }),
    
    computed: {
        itemQtyToBeDisplayed(): string {
            if(this.currentSelectedReplacement.isWeightSensitive == true) {
              return WeightedProductUnitMeasure.getTotalWeightValueInCorrectUnit(this.currentSelectedReplacement.unitMeasure * this.parentItemObject.quantity, this.currentSelectedReplacement.unitMeasureCode)
            }

            else {
                return this.parentItemObject.quantity.toString()
            }
        }
    },


    methods: {
        getItemStatus(): EItemReplacementStatus {
            if(this.itemObject.originalItem.isEmployeeForceDiscarded || !this.itemObject.originalItem.hasAlternatives) {
                return EItemReplacementStatus.removedFromOrder
            }

            else if(this.itemObject.isDiscarded) {
                return EItemReplacementStatus.replacementDiscarded;
            }

            else if(this.itemObject.replacementItem == null && !this.itemObject.isDiscarded) {
                return EItemReplacementStatus.pendingSelection
            }

            else 
                return EItemReplacementStatus.replaced;
        },

        decreaseQuantity() {
            this.$emit("decreaseQuantity", this.parentItemObject)
        },

        increaseQuantity() {
            this.$emit("increaseQuantity", this.parentItemObject)
        },
    }
})

